import { useQuery } from "@tanstack/react-query"
import { getClientInfo, ClientInfo } from "@/api"

export const useClientInfo = (clientId?: number | null) => {
  const query = useQuery<ClientInfo>({
    queryKey: ["clientInfo", clientId],
    queryFn: () => getClientInfo(clientId!),
    enabled: clientId != null,
    staleTime: 1000 * 60 * 5,
  })

  return {
    ...query,
    data: query.data || null,
  }
}
